import {Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {BrowseConfig} from "@core/bean/browse-config";
import {BrowseService} from "@shared/components/browse/browse.service";
export const EXE_COUNTER_VALUE_ACCESSOR:any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BrowseButtonComponent),
  multi: true
};
@Component({
  selector: 'app-browse-button',
  templateUrl: './browse-button.component.html',
  styles: [],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class BrowseButtonComponent implements OnInit {
  /**
   * input绑定的name
   * */
  @Input() name:string;
  /**
   * 浏览按钮要打开的browse组件名
   * */
  @Input() browseComponent:string;
  /**
   * 是否必填
   * */
  @Input() required:boolean;
  /**
   * 按钮是否disabled
   * */
  @Input() disabled:boolean;

  /**
   * 输入框是否可编辑
   * */
  @Input() inputIsEdit:boolean;
  /**
   * 是否多选
   * */
  @Input() multiple:boolean;
  /**
   * 浏览按钮弹框内是否可选择
   * */
  @Input() browseIsEdit:boolean;

  /**
   * 搜索条件
   * */
  @Input() searchData:any = {};

  /**
   * 是否用公用的浏览按钮
   * */
  @Input() isCommons:boolean;

  /**
   * 业务参数
   * apiUrl：后端接口地址 例如：'api/company'
   *searchFormList：表单筛选条件，数组，例如[{label:'公司名称',value:'companyName'},{label:'公司代码',value:'companyCode'}]
   * tableFieldList：表格里面要展示的数据。数组，例如[{label:'公司代码',value:'companyCode'},{label:'公司名称',value:'companyName'}]
   *title:列表title
   * config：业务配置参数，{multiple:true,searchData:{}},multiple为是否多选，searchData：默认带的搜索条件
   * */
  @Input() commonsObj;

  /**
   * sap数据公用浏览按钮处理参数
   * */
  /**
   * 启用sap基础数据浏览按钮
   * */
  @Input() sapBrowseCommons:boolean;
  /**
   * 业务参数
   *searchFormList：表单筛选条件，数组，例如[{label:'公司名称',value:'companyName'},{label:'公司代码',value:'companyCode'}]
   * tableFieldList：表格里面要展示的数据。数组，例如[{label:'公司代码',value:'companyCode'},{label:'公司名称',value:'companyName'}]
   *title:列表title
   * config：业务配置参数，{multiple:true,searchData:{}},multiple为是否多选，searchData：默认带的搜索条件,业务条件放到searchData中
   * */
  @Input() sapCommonsObj;

  @Output() private selectData = new EventEmitter(); //选择数据时的回调
  @Output() private clear = new EventEmitter(); //清楚数据时的回调
  @Output() private cancel = new EventEmitter();//点击取消时的回调

  constructor(private browseService:BrowseService) { }

  ngOnInit() {
  }
  innerValue:any;
  propagateChange = (_:any) => {
  };
  writeValue(obj:any):void {
    this.innerValue = obj;
  }
  registerOnChange(fn:any):void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn:any):void {
  }
//供应商浏览按钮
  browseConfig: BrowseConfig;

  valueChange(val){
    this.propagateChange(val);
  }

  //选择数据时的回调
  select(){
    if(this.isCommons){
      this.commonsBrowse.initData();
      return;
    }
    if(this.sapBrowseCommons){
      this.sapCommonsBrowser.initData();
      return;
    }
    this.browseConfig = new BrowseConfig(this.browseComponent);
    this.browseConfig.searchData = this.searchData;
    if(this.multiple){
      this.browseConfig.multiple = true;
    }
    if(this.browseIsEdit !== false){
      this.browseConfig.isEdit = true;
    }
    this.browseService.open(this.browseConfig,
      (result) => {
      this.selectData.emit(result);
      },
      ()=>{
      this.cancel.emit();
      }
      )
  }

  //清空数据时的回调
  clearData(){
    this.clear.emit();
    setTimeout(() => {
      this.propagateChange(this.innerValue);
    },0);
  }

//  使用公用浏览按钮时
  @ViewChild('commonsBrowse') commonsBrowse;
  @ViewChild('sapCommonsBrowser') sapCommonsBrowser;
//  选中数据回调
  chooseData(result){
    this.selectData.emit(result);
  }
}
